import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'

const bundleSlice = createSlice({
  name: 'bundles',
  initialState: {
    allBundles: [],
    bundlesLoaded: false,
  },
  reducers: {
    setAllBundles(state, action) {
      state.allBundles = action.payload
      state.bundlesLoaded = true
    },
    addBundle(state, action) {
      state.allBundles.push(action.payload)
    },
    removeBundle(state, action) {
      state.allBundles = state.allBundles.filter(b => b.id !== action.payload)
    },
    clearBundles(state) {
      state.allBundles = []
      state.bundlesLoaded = false
    },
  },
})

export const { setAllBundles, addBundle, removeBundle, clearBundles } =
  bundleSlice.actions

/**
 * Hae kaikki niputukset. Palauttaa cachesta jos jo ladattu.
 */
export const initializeBundles = token => {
  return async (dispatch, getState) => {
    const { bundles } = getState()
    if (bundles.bundlesLoaded) {
      return bundles.allBundles
    }
    try {
      const response = await axios.get('/api/bundles', {
        headers: { 'x-oauth-token': token },
      })
      dispatch(setAllBundles(response.data))
      return response.data
    } catch (error) {
      console.error('Error fetching bundles:', error)
      return []
    }
  }
}

/**
 * Luo uusi nippu
 */
export const createBundle = (candidateIds, token) => {
  return async dispatch => {
    try {
      const response = await axios.post(
        '/api/bundles',
        { candidateIds },
        { headers: { 'x-oauth-token': token } }
      )
      dispatch(addBundle(response.data))
      return response.data
    } catch (error) {
      console.error('Error creating bundle:', error)
      throw error
    }
  }
}

/**
 * Poista nippu
 */
export const deleteBundle = (bundleId, token) => {
  return async dispatch => {
    try {
      await axios.delete(`/api/bundles/${bundleId}`, {
        headers: { 'x-oauth-token': token },
      })
      dispatch(removeBundle(bundleId))
    } catch (error) {
      console.error('Error deleting bundle:', error)
      throw error
    }
  }
}

export default bundleSlice.reducer
